import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http'
import {environment} from '@environments/environment';
import {UserProfile} from '@interfaces/user-profile.interface';
import {BehaviorSubject, map, Observable, tap} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private _userId: string;
  private _userProfile: UserProfile;
  userProfile$ = new BehaviorSubject<UserProfile>({} as UserProfile);

  constructor(private http: HttpClient) {
  }

  get userId(): string {
    return this._userId
  }

  get userProfile() {
    return this._userProfile
  }

  createUser(payload: any): Observable<any> {
    return this.http.put(environment.BACKEND_API_URL + '/v1/user', payload);
  }

  updateUser(payload: any): Observable<UserProfile> {
    return this.http.patch(environment.BACKEND_API_URL + '/v1/user', payload).pipe(
      map((res: any) => res.body as UserProfile),
      tap((profile: UserProfile) => {
        profile.image.url = environment.RESOURCES_URL + profile.image.url
        this.setUserProfile(profile)
      })
    );
  }

  createCompany(payload: any) {
    return this.http.put(environment.BACKEND_API_URL + '/v1/company', payload);
  }

  getUser(): Observable<UserProfile> {
    return this.http.get(environment.BACKEND_API_URL + '/v1/user').pipe(
      map((res: any) => res.body as UserProfile),
      tap((profile: UserProfile) => {
        if (profile?.image?.url) profile.image.url = environment.RESOURCES_URL + profile.image.url
        this.setUserProfile(profile)
      })
    );
  }

  getBadgers() {
    return this.http.get(environment.BACKEND_API_URL + '/v1/statistics/badgers')
  }

  getCompany() {
    return this.http.get(environment.BACKEND_API_URL + '/v1/company');
  }

  getFriends(pageSize: any, currentPage: any): Observable<any> {
    return this.http.get(environment.BACKEND_API_URL + `/v1/user-friend/grouped?size=${pageSize}&page=${currentPage}`);
  }

  markAsFavorite(email: string, favorite: boolean): Observable<any> {
    const payload = {email, favorite};
    return this.http.patch(environment.BACKEND_API_URL + '/v1/user-friend/favorite', payload);
  }

  getActiveFriends(pageSize: number, currentPage: number, filter: string): Observable<any> {
    return this.http.get(environment.BACKEND_API_URL + `/v1/user-friend/grouped?status=ACTIVE&size=${pageSize}&page=${currentPage}&like=${filter}`);
  }

  friendLookup(data: any) {
    return this.http.post(environment.BACKEND_API_URL + '/v1/user-friend/lookup', data)
  }

  updateFriend(data: any) {
    return this.http.patch(environment.BACKEND_API_URL + '/v1/user-friend', data)
  }

  logout() {
    this.setUserProfile({} as UserProfile);
  }

  private setUserProfile(userProfile: UserProfile) {
    this._userProfile = userProfile;
    this._userId = userProfile.internal_user_id;
    this.userProfile$.next(userProfile);
  }

}
